<!--
 * @Author: 徐艳龙 w17630400757@163.com
 * @Date: 2022-05-07 14:35:21
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-06-02 17:28:39
 * @FilePath: \Home\Transfor-website\src\views\pc\Home\homeConter.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="homeConter">
      <div class="homeConter-W">
        <div class="homeConter-Top">
          <p>
            <span></span><span>{{ $t("Main.AboutTransformers") }}</span>
          </p>
        </div>
        <div class="homeConter-A">
          <p>
            <span>A whole</span> <span> experience</span
            ><span> for you with transformers.</span>
          </p>
        </div>
        <div>
          <ul>
            <li>
              <p>
                {{ $t("Main.lows") }}
                <img src="../../../assets/pc/Home/Home2.png" />
              </p>
              <p>
                <span></span>
                <span></span>
              </p>
              <p>
                With the lightweight Raindrop consensus protocol in the
                transformer network, transactions can complete two-thirds of the
                network consensus within 5 seconds, processing thousands of
                transactions per second.
              </p>
            </li>
            <li>
              <p>
                On-chain scalability
                <img src="../../../assets/pc/Home/Home4.png" />
              </p>
              <p>
                <span></span>
                <span></span>
              </p>
              <p>
               Transformers uses a double VRF random number algorithm to elect multiple candidates for block production at the same timestamp and to continuously scale the number of candidates as the network grows in size.

              </p>
            </li>
            <li>
              <p>
                {{ $t("Main.Fast") }}
                <img src="../../../assets/pc/Home/Home1.png" />
              </p>
              <p>
                <span></span>
                <span></span>
              </p>
              <p>
                The network interaction can be completed with the minimum
                payment of TTOS and can complete the transaction time within 2
                seconds at the most immediate.
              </p>
            </li>
            <li>
              <p>
               The Chain Structure
                <img src="../../../assets/pc/Home/Home3.png" />
              </p>
              <p>
                <span></span>
                <span></span>
              </p>
              <p>
                Multiple blocks are co-existed at each height of the Transformers network. The peak of each block is quickly confirmed during the consensus process, providing a more reliable mechanism for up-chaining when multiple candidates process block transactions in parallel.

              </p>
              <!-- <i></i> -->
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {};
  },

  mounted() {},

  methods: {
    
  },
};
</script>

<style lang="less" scoped>
.homeConter {
  width: 100%;
  background: #f4f4f4;

  .homeConter-W {
    width: 1320px;
    margin: 0 auto;
    background: #f4f4f4;
    padding-bottom: 208px;
    .homeConter-Top {
      p {
        padding: 177px 0 35px 0;
        span:nth-child(1) {
          width: 60px;
          height: 4px;
          background: #141414;
          display: inline-block;
          margin-right: 30px;
        }
        span:nth-child(2) {
          font-size: 24px;
          font-family:"Microsoft YaHei";
          //font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
          font-weight: 900;
          color: #141414;
          line-height: 34px;
        }
      }
    }
    .homeConter-A {
      margin-bottom: 60px;
      p {
        width: 798px;
        // height: 140px;
        font-size: 60px;
        font-family:"Microsoft YaHei";
       // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
        font-weight: 900;
        color: #141414;
        line-height: 84px;
      }
      span:nth-child(2) {
        color: #cf61dc;
      }
    }
    ul {
      display: flex;
      li {
        p {
          position: relative;
          img {
            width: 80px;
            height: 80px;
            position: absolute;
            right: 30px;
            bottom: 24px;
          }
        }
      }
      li:hover {
        p:nth-child(1) {
          color: #cf61dc !important;
        }
      }
      li:nth-child(2) {
        margin: 0 20px;
        p:nth-child(1) {
          width: 315px;
          height: 200px;
          background: #141414;
          padding: 24px 54px 0 34px;
          font-size: 18px;
          font-family:"Microsoft YaHei";
         // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
          font-weight: 900;
          color: #ffffff;
          line-height: 25px;
        }
      }
      li:nth-child(3) {
        margin-right: 20px;
        p:nth-child(1) {
          width: 315px;
          height: 200px;
          background: #141414;
          padding: 24px 54px 0 34px;
          font-size: 18px;
          font-family:"Microsoft YaHei";
       //   font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
          font-weight: 900;
          color: #ffffff;
          line-height: 25px;
        }
      }
      li:nth-child(1) {
        p:nth-child(1) {
          width: 315px;
          height: 200px;
          background: #141414;
          padding: 24px 50px 0 34px;
          font-size: 18px;
          font-family:"Microsoft YaHei";
         // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
          font-weight: 900;
          color: #ffffff;
          line-height: 25px;
        }
      }
      li:nth-child(4) {
        position: relative;
        p:nth-child(1) {
          width: 315px;
          height: 200px;
          background: #141414;
          padding: 24px 54px 0 34px;
          font-size: 18px;
          font-family:"Microsoft YaHei";
        //  font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
          font-weight: 900;
          color: #ffffff;
          line-height: 25px;
        }
        i {
          display: inline-block;
          width: 464px;
          height: 408px;
          background: #cf61dc;
          opacity: 0.2;
          border-radius: 50%;
          -webkit-filter: blur(9px);
          filter: blur(60px);
          filter: blur(undefinedpx);
          position: absolute;
          top: -235px;
          left: 0;
        }
      }
      li {
        flex: 1;
        width: 315px;
        p:nth-child(3) {
          font-size: 16px;
          font-family:"Microsoft YaHei";
        //  font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
          font-weight: 500;
          color: #141414;
          line-height: 24px;
        }
        span {
          width: 3px;
          height: 6px;
          background: #cf61dc;
          display: inline-block;
          margin: 12px 0;
        }
        span:nth-child(1) {
          margin-right: 2px;
        }
      }
    }
  }
}
</style>
